import { useLocation, useNavigate } from "react-router-dom";
import { Mode } from "../../types";
import { useMemo, useState } from "react";
import { useUIStore, useGroupListStore } from "../../store";
import { IconBtnProps } from "../../../../components/btn";
import { useMediaMd } from "../../../../hooks/useMedia";
import { useUserQuery } from "../queries/useUserQuery";
import { useAuth } from "../useAuth";
import { useChatHistoryQuery } from "../queries/useChatHistoryQuery";

const useAirHeaderView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isMd = useMediaMd();
  const { isLoggedIn } = useUserQuery();
  const { redirectToLogin, checkLoginBeforeAction } = useAuth();
  const { toggleNav, setShareModalOpen } = useUIStore();
  const { currentGroupId } = useGroupListStore();

  // TODO: V2 테스트용 routes 수정
  const tutorPages = ["/", "/tutor", ""];

  // 현재 페이지에 따라 mode 결정
  const mode = tutorPages.find((path) => path === location.pathname)
    ? Mode.TUTOR
    : location.pathname === "/socrates"
    ? Mode.SOCRATES
    : Mode.TUTOR; // 기본값

  // 채팅 히스토리 조회
  const { data: chatHistory } = useChatHistoryQuery({
    mode,
    groupId: currentGroupId,
  });

  const [internalToggleActive] = useState(
    location.pathname === "/" || location.pathname === "/tutor"
    // TODO: V2 테스트용 routes 수정
    // location.pathname === "/tutor-v2"
  );

  const handleToggleMode = (newMode: Mode) => {
    let currentPage = "";

    if (tutorPages.find((path) => path === location.pathname))
      currentPage = "tutor";
    else if (location.pathname === "/socrates") currentPage = "socrates";
    else currentPage = "other";

    if (newMode === Mode.SOCRATES && currentPage !== "socrates") {
      navigate("/socrates");
    } else if (newMode === Mode.TUTOR && currentPage !== "tutor") {
      navigate("/tutor");
    }
  };

  const subBtn: IconBtnProps | undefined = useMemo(() => {
    // 나의활동 페이지에서는 홈버튼 표시
    if (location.pathname === "/my-activity") {
      return {
        icon: "Home",
        onClick: () => {
          navigate("/tutor");
        },
      };
    }

    // 채팅 내용이 있으면 share 버튼 표시
    if (chatHistory && chatHistory.length > 0) {
      return {
        icon: "Share",
        onClick: () => {
          setShareModalOpen(true);
        },
      };
    }

    if (!isMd) {
      if (!isLoggedIn) {
        return {
          icon: "User",
          onClick: checkLoginBeforeAction(() =>
            window.open(
              process.env.REACT_APP_DONGA_MYPAGE ||
                "https://my.dongascience.com",
              "_blank"
            )
          ),
        };
      }
    }

    return null;
  }, [
    location.pathname,
    navigate,
    chatHistory,
    isLoggedIn,
    isMd,
    checkLoginBeforeAction,
    setShareModalOpen,
  ]);

  const handleClickGuide = () => navigate("/guide/main");

  const handleClickLogin = () => redirectToLogin();

  const handleClickMenu = () => toggleNav();

  const handleClickBack = () => {
    // 소크라테스 면접 관련 페이지에서는 /socrates로 직접 이동
    if (
      location.pathname.match(/^\/socrates\/\d+/) ||
      location.pathname === "/socrates/new"
    ) {
      navigate("/socrates");
    } else {
      navigate(-1);
    }
  };

  const handleClickLogo = () => navigate("/");

  // 메인 페이지인지 확인 (튜터 메인: /, /tutor / 소크라테스 메인: /socrates)
  const isMainPage = useMemo(() => {
    return (
      location.pathname === "/" ||
      location.pathname === "/tutor" ||
      location.pathname === "/socrates"
    );
  }, [location.pathname]);

  return {
    subBtn,
    internalToggleActive,
    isMainPage,
    handleToggleMode,
    handleClickGuide,
    handleClickLogin,
    handleClickMenu,
    handleClickBack,
    handleClickLogo,
  };
};

export default useAirHeaderView;
